import * as React from "react"
import { Fragment, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useTranslate } from "ra-core"
import {
    BulkDeleteWithConfirmButton,
    DatagridConfigurable,
    List,
    TopToolbar,
    CreateButton,
    FilterButton,
    SelectColumnsButton,
    ExportButton,
    TextField,
    TextInput,
    DateField,
    WrapperField,
    ShowButton,
    EditButton,
    CloneButton,
    BulkExportButton,
    FunctionField,
} from "react-admin"
import * as buttons from "components/ui/buttons"
import DashboardCreationWizardMUI from './create.wizard'


const getDashboardFilters = (): React.ReactElement[] => {
    return [
        <TextInput source="name" />,
        <TextInput source="description" />,
    ]
}


const ListActions = ({ onCreateClick }: { onCreateClick: () => void }) => (
    <TopToolbar>
        <CreateButton onClick={(e) => { e.preventDefault(); onCreateClick(); }} />
        <FilterButton />
        <SelectColumnsButton />
        <ExportButton />
    </TopToolbar>
)

const PostBulkActionButtons = () => (
    <Fragment>
        <BulkExportButton />
        <BulkDeleteWithConfirmButton mutationMode="optimistic"/>
    </Fragment>
)


const DashboardList = () => {
    const translate = useTranslate()
    const navigate = useNavigate()
    const [showCreateWizard, setShowCreateWizard] = useState(false)

    const handleCreateClick = () => {
        setShowCreateWizard(true)
    }

    const handleWizardClose = () => {
        setShowCreateWizard(false)
    }

    const handleWizardSuccess = (dashboardId: string) => {
        setShowCreateWizard(false)
        navigate(`/dashboards/management/${dashboardId}`)
    }

    return (
        <>
        <List
            filters={getDashboardFilters()}
            sort={{ field: "updated_at", order: "DESC" }}
            actions={<ListActions onCreateClick={handleCreateClick} />}
        >
            <DatagridConfigurable sx={{
                "& .RaDatagrid-headerCell": { 
                    fontWeight: 'bold' 
                }
            }} bulkActionButtons={<PostBulkActionButtons/>}>
                <TextField source="name" label={translate("resources.dashboards.fields.name")} />
                <TextField source="description" label={translate("resources.dashboards.fields.description")} />
                
                <FunctionField 
                    label={translate("resources.dashboards.fields.widgets_count")} 
                    render={(record: any) => record.widgets_count || 0}
                />
                
                <FunctionField 
                    label={translate("resources.dashboards.fields.is_public")}
                    render={(record: any) => record.is_public 
                        ? translate("resources.dashboards.values.public") 
                        : translate("resources.dashboards.values.private")
                    }
                />
                
                <DateField showTime source="created_at" label={translate("resources.common.fields.created_at")} />
                <DateField showTime source="updated_at" label={translate("resources.common.fields.updated_at")} />
                
                <WrapperField label={translate("internal.actions")}>
                    <ShowButton label="" title={translate("ra.action.show")} />
                    <EditButton label="" title={translate("ra.action.edit")}/>
                    <CloneButton label="" title={translate("ra.action.clone")}/>
                    <buttons.DeleteWithConfirmButtonX title={translate("ra.action.remove")} field="name" />
                </WrapperField>
            </DatagridConfigurable>
        </List>
        
        <DashboardCreationWizardMUI
            open={showCreateWizard}
            onClose={handleWizardClose}
            onSuccess={handleWizardSuccess}
        />
        </>
    )
}

export default DashboardList
